import max from 'lodash/max';
import min from 'lodash/min';

import { JobBlock } from '@/lib/types';

import { SpecialtyPage } from '@/features/specialty-page';
import filterMainComponent from '@/features/specialty-page/utils/filter-main-component.util';
import PublicJobsService, { Job } from '@/services/public-jobs.service';

const get = async (specialtyPage: SpecialtyPage, jobBlock: JobBlock) => {
  return PublicJobsService.getAll({
    specialties: specialtyPage.specialty?.title,
    discipline: specialtyPage.specialty?.discipline?.apiId as string,
    // min 4 | max 10
    limit: min([max([jobBlock.limit || 0, 4]), 10]),
  });
};

export type JobBlocksMap = Record<string, Job[]>;

const getAll = async (specialtyPage: SpecialtyPage): Promise<JobBlocksMap> => {
  if (!specialtyPage.specialty?.discipline?.id) return {};

  const jobsComponents = filterMainComponent<JobBlock>(
    specialtyPage,
    'JobBlock'
  );

  if (!jobsComponents.length) return {};

  const props = await Promise.all(
    jobsComponents.map(async (c): Promise<[string, Job[]]> => {
      const { jobs } = await get(specialtyPage, c);
      return [c.id, jobs];
    })
  );

  return Object.fromEntries(props);
};

const JobBlocksService = {
  getAll,
};

export default JobBlocksService;
